import CompareTable from "../Pharmacy/PharmacyPlan/PharmacyCompareTable";
import { TABLE_STYLES } from "../Pharmacy/PharmacyPlan/PharmacyPlan.constants";
import { getDefaultCollapsed, ORIGIN_TITLE, shouldIncludeComparisonItem, STICKY_HEADER_HEIGHT, TARGET_TITLE } from "./Compare.constants";
import CompareRow from "./CompareRow";
import { CompareTitle } from "./CompareTitle";
import CustomPanel, { EPanelStyleType } from "./CustomPanel";
import { IEntityMetadataSectionProps } from "./types";

const EntityTiersPanel: React.FC<IEntityMetadataSectionProps> = (props) => {
    if (props.entityProps.compareVM.tiersVM && (props.entityProps.compareVM.tiersVM.rowsVM.length ?? 0) > 0) {
        if (shouldIncludeComparisonItem(props.entityProps.configuration.showDifferencesOnly, props.entityProps.compareVM.tiersVM.changed)) {
            const tierRows: JSX.Element[] = [];

            props.entityProps.compareVM.tiersVM.rowsVM.forEach((property) => {
                if (!shouldIncludeComparisonItem(props.entityProps.configuration.showDifferencesOnly, property.changed)) {
                    return;
                }

                tierRows.push(
                    <CompareRow
                        key={property.propertyDefinition.name}
                        name={<CompareTitle
                            changed={property.changed}
                            name={property.propertyDefinition.name}
                            entityProps={props.entityProps}
                        />}
                        valueVM={{
                            origin: property.origin,
                            target: property.target,
                            changed: property.changed,
                            mergeAction: property.mergeAction,
                        }}
                        entityProps={props.entityProps}
                    />
                );
            });

            return (
                <CustomPanel
                    id={`${props.entityProps.compareVM.uniqueId}-tiers`}
                    key={`${props.entityProps.compareVM.uniqueId}-tiers`}
                    data-tiers={'true'}
                    title={<CompareTitle
                        changed={props.entityProps.compareVM.tiersVM.changed}
                        name={'Tiers'}
                        entityProps={props.entityProps}
                    />}
                    defaultCollapsed={getDefaultCollapsed(props.entityProps.configuration, props.entityProps.compareVM.tiersVM.changed)}
                    canCollapse={true}
                    stickyHeader={true}
                    stickyTop={props.entityProps.stickyOffset + STICKY_HEADER_HEIGHT}
                    stickyZIndex={150}
                    styleType={EPanelStyleType.Default}
                >
                    <CompareTable
                        className={props.entityProps.classNames}
                        tableStyles={TABLE_STYLES}
                        originHeader={ORIGIN_TITLE}
                        targetHeader={TARGET_TITLE}
                    >
                        {tierRows}
                    </CompareTable>
                </CustomPanel>
            );
        }
    }

    return null;
};

export default EntityTiersPanel;